import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Clock, ImageOff, Car, Globe2, LayoutDashboard } from 'lucide-react';
const problems = [{
  icon: <Clock className="w-6 h-6 text-white" data-id="element-141" data-mp="2pepivmp173nr" />,
  title: 'Wasted Inspections',
  description: "Hours lost visiting properties that don't match your requirements."
}, {
  icon: <ImageOff className="w-6 h-6 text-white" data-id="element-142" data-mp="2gd97pcqe6xih" />,
  title: 'Misleading Photos',
  description: 'Static images often hide flaws and misrepresent actual space.'
}, {
  icon: <Car className="w-6 h-6 text-white" data-id="element-143" data-mp="26hoart06knfl" />,
  title: 'Traffic & Logistics',
  description: 'The stress of navigating Lagos traffic for multiple viewings.'
}, {
  icon: <Globe2 className="w-6 h-6 text-white" data-id="element-144" data-mp="1wqbl981uu9cq" />,
  title: 'Diaspora Challenges',
  description: 'Expatriates struggle to verify properties remotely before relocating.'
}, {
  icon: <LayoutDashboard className="w-6 h-6 text-white" data-id="element-145" data-mp="1npvik0sxr68x" />,
  title: 'Layout Confusion',
  description: 'Difficulty understanding the true flow and scale of a property.'
}];
export function Problem() {
  return <section className="py-24 bg-zinc-950 relative" data-id="element-146" data-mp="o9sl9e8tl9bk">
      <div className="max-w-7xl mx-auto px-6" data-id="element-147" data-mp="od6muk9ntehy">
        <FadeIn className="mb-16" data-id="element-148" data-mp="129k884hbe01p">
          <h2 className="text-3xl md:text-4xl font-display font-medium text-white mb-4" data-id="element-149" data-mp="128iufs8wyzga">
            The traditional property search is broken.
          </h2>
          <p className="text-zinc-400 text-lg max-w-2xl" data-id="element-150" data-mp="9mzfp0p3rhwk">
            House-hunting in Nigeria comes with unique pain points. We built
            MUNISVerse to solve them.
          </p>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-151" data-mp="jcsoxv1rvkxn">
          {problems.map((problem, index) => <FadeIn key={index} delay={index * 0.1} className={`glass-panel p-8 rounded-3xl ${index === 3 ? 'lg:col-span-2 lg:col-start-1' : ''} ${index === 4 ? 'lg:col-span-1' : ''}`} data-id="element-152" data-mp="ejpw5p4tkfii" data-mpi={index}>
              <div className="w-12 h-12 rounded-full bg-white/10 flex items-center justify-center mb-6" data-id="element-153" data-mp="1lywd305ukzil">
                {problem.icon}
              </div>
              <h3 className="text-xl font-medium text-white mb-3" data-id="element-154" data-mp="1qvv4hay4msd3">
                {problem.title}
              </h3>
              <p className="text-zinc-400 leading-relaxed" data-id="element-155" data-mp="1vqsae9040llr">
                {problem.description}
              </p>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}